export default __webpack_public_path__ + "static/media/bg.7fa45dda.svg";